import React from "react";
import clsx from "clsx";

import { IAccordion } from "./Accordion";
import { DownCircleIcon, UpCircleIcon } from "../../../assets/Icons";

const Accordion: React.FC<IAccordion.AccordionProps> = ({
  title,
  width,
  children,
  customClassname,
  openAccordion = <DownCircleIcon />,
  closeAccordion = <UpCircleIcon />,
  handleOnClick = () => true,
  titleClassname,
}) => {
  const [isAccordionOpen, setOpenAccordion] = React.useState<boolean>(false);

  const handleOnClicks: any = () => {
    setOpenAccordion((isAccordionOpen) => !isAccordionOpen);
    handleOnClick();
  };

  return (
    <div
      // onClick={() => setOpenAccordion(!isAccordionOpen)}
      className={clsx(
        "flex flex-col justify-center h-auto rounded-xl px-8 py-4 cursor-pointer",
        width,
        customClassname,
      )}
    >
      <div className="flex items-center">
        <div className={clsx("flex-1", titleClassname)}>{title}</div>
        <div onClick={handleOnClicks} className="cursor-pointer">
          {isAccordionOpen ? closeAccordion : openAccordion}
        </div>
      </div>
      {isAccordionOpen && <div className="mt-8">{children}</div>}
    </div>
  );
};

export default Accordion;
